import type { QueryParamsDto } from "@mimber/schema"

/**
 * Query key utilities for dues hooks
 * Keys match backend controller method names
 */
export const duesKeys = {
  getSettings: () => ["dues", "getSettings"] as const,
  getDashboard: () => ["dues", "getDashboard"] as const,
  getOverdueMembers: () => ["dues", "getOverdueMembers"] as const,
  getUpcomingDues: () => ["dues", "getUpcomingDues"] as const,
  findAllInvoices: (params?: QueryParamsDto) =>
    params
      ? (["dues", "findAllInvoices", params] as const)
      : (["dues", "findAllInvoices"] as const),
} as const
